import firebase from 'firebase'
import 'firebase/firestore'

//const firebaseApp = firebase.initializeApp(firebaseConfig)
const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings)
export default firebase.firestore()

